import { CheckIcon } from "@heroicons/react/solid";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSignMessage } from 'wagmi'
import { getFromApi, postToAPI } from "../../helpers/api";

const Minting = (props) => {
  const [addedToSoundBasket, setAddedToSoundBasket] = useState(false);
  const [update, setUpdate] = useState(false);
  const { data, error, isLoading, signMessage } = useSignMessage({
    onSuccess(data, variables) {
      // Verify signature when sign message succeeds
      console.log({ signature: data });         
      verifySignature(data);        
    },
  });

  useEffect(() => {
    if(addedToSoundBasket) {
      setTimeout(() => {
        setUpdate(true);
      }, 1500)
    }
  }, [addedToSoundBasket]);

  const verifySignature = async (signature) => {
    try {
      const json = await postToAPI("message", {signature, artistInfo: props.info}, null, false);
      console.log(json);
      setAddedToSoundBasket(true);
    } catch (error) {
      console.log(error);
    }
  }

  const handleSignMessage = async () => {
    // const res = await fetch("http://localhost:3000/message");
    // const message = await res.text();  
    const message = await getFromApi("message");  
    signMessage({ message: message.message })
  };

  const renderSuccessPage = () => {
    if(update) {
      return (
        <div>
        <a href={props.info.website.includes("http") ? props.info.website : `https://${props.info.website}`}          
          className="bg-black text-white py-4 px-8 rounded-sm"
        >
          Visit {props.info.name}{"'s"} site
        </a>
        <p className="mt-8 text-sm">
          <Link to="/mysounds"><u>Go to your SoundBasket</u></Link>
        </p>
      </div>
      )
    } else {
      return (
        <div className="w-3/4 m-auto text-center mt-12">
          <div className="flex flex-row align-center justify-center"><CheckIcon className="font-light h-6 w-6 mr-2" /> <p>Added to your SoundBasket</p></div>
        </div>
      )
    }
  }

  return (
    <div className="h-full">
      <div className="h-96 w-screen">
        <img
          className="h-full object-cover w-screen"
          src={props.info.nftImage}
        />
      </div>
      <div className="w-3/4 m-auto text-center mt-8">
        <p>You've unlocked</p>
        <h1 className="text-2xl mt-2 mb-4">{props.info.nftName}</h1>
        <p>{props.info.nftDescription}</p>
      </div>
      <div className="text-center mt-8">
        {addedToSoundBasket ? (
          <div>{renderSuccessPage()}</div>
        ) : (
          <div>
            <button
              onClick={handleSignMessage}
              className="bg-black text-white py-4 px-8 rounded-sm"
            >
              Add to soundbasket
            </button>
            <p className="mt-8">
              <Link to="/discover"><u>or listen to another song</u></Link>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Minting;
